<template>
  <article>
    <div style="background:#eee;padding: 20px">
      <Card :bordered="false">
        <h4 slot="title">身份验证</h4>
        <Row>
          <Col span='12'>
            <h5>身份证正面（号码面）</h5>
            <Upload :on-exceeded-size='maxSizeErr' ref="uploadFirstCardImg" name="file" v-if="cardCanUpload" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError"
              :max-size="4096" :data="uploadData" :before-upload="()=>handleBeforeUpload('uploadFirstCardImg')" :on-success="handleSuccess" action="//upload.qiniup.com">
              <div v-if="!cardImg.first" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>身份证正面（号码面）</p>
              </div>
              <div v-if="cardImg.first" class="img-box">
                <img class="img" :src="cardImg.first" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>证件照正面</p>
                </div>
              </div>
            </Upload>
            <div v-if="!cardCanUpload" class="cardImg">
              <div class="upload-box">
                <img class="img" :src="cardImg.first" alt="" width="100%">
              </div>
            </div>
          </Col>
          <Col span='12'>
            <h5>身份证反面（国徽面）</h5>
            <Upload :on-exceeded-size='maxSizeErr' ref="uploadSecondCardImg" v-if="cardCanUpload" name="file" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError"
              :max-size="4096" :data="uploadData" :before-upload="()=>handleBeforeUpload('uploadSecondCardImg')" :on-success="handleSuccess" action="//upload.qiniup.com">
              <div v-if="!cardImg.second" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>身份证反面（国徽面）</p>
              </div>
              <div v-if="cardImg.second" class="img-box">
                <img class="img" :src="cardImg.second" alt="" width="100%">
                <div class="upload-bord">
                  <p>
                    <Icon type="md-add-circle" style="font-size:40px"></Icon>
                  </p>
                  <p>证件照反面</p>
                </div>
              </div>
            </Upload>
            <div v-if="!cardCanUpload" class="cardImg">
              <div class="upload-box">
                <img class="img" :src="cardImg.second" alt="" width="100%">
              </div>
            </div>
          </Col>
        </Row>
        <Form>
          <FormItem class="tableForm" label="姓名：" :label-width="100">
            <span>{{cardInfo.name || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="身份证号：" :label-width="100">
            <span>{{cardInfo.cardId || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="有效期：" :label-width="100">
            <span>{{cardInfo.idValidDate || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="审核状态：" :label-width="100">
            <span>{{['未验证','待审核','已验证','审核不通过','未完成'][cardInfo.status] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="原因：" :label-width="100">
            <span>{{info.idCheckResult || '-'}}</span>
          </FormItem>
        </Form>
        <Row>
          <Button :disabled="!(cardCanUpload&& cardImg.first && cardImg.second)" :loading="btnLoading.omsCardBtn" @click="omsCardAudit">使用照片审核</Button>
          <Button @click="cardVerifyBtn">人工审核身份证</Button>
        </Row>
      </Card><br>
      <Card :bordered="false">
        <h4 slot="title">人脸识别验证</h4>
        <Row>
          <Col span='12'>
            <Upload :on-exceeded-size='maxSizeErr' ref="uploadFaceImg" v-if="faceCanUpload" name="file" class="upload" :show-upload-list="false" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError"
              :max-size="4096" :data="uploadData" :before-upload="()=>handleBeforeUpload('uploadFaceImg')" :on-success="handleSuccess" action="//upload.qiniup.com">
              <div v-if="!faceImg" class="upload-box">
                <p>
                  <Icon type="md-add-circle" style="font-size:40px"></Icon>
                </p>
                <p>人脸识别照片</p>
              </div>
              <div v-if="faceImg" class="img-box">
                <img class="img" :src="faceImg" alt="" width="100%">
              </div>
            </Upload>
            <div v-if="!faceCanUpload" class="cardImg">
              <div class="upload-box">
                <img class="img" :src="faceImg" alt="" width="100%">
              </div>
            </div>
          </Col>
        </Row>
        <Form>
          <FormItem class="tableForm" label="审核状态：" :label-width="100">
            <span>{{['未验证','待审核','已验证','审核不通过','未完成'][faceInfo.status] || '-'}}</span>
          </FormItem>
          <FormItem class="tableForm" label="原因：" :label-width="100">
            <span>{{info.faceRejectReason || '-'}}</span>
          </FormItem>
        </Form>
        <Row>
          <Button :disabled="!((cardInfo.status==2)&&faceCanUpload&&faceImg)" :loading="btnLoading.omsFaceBtn" @click="omsFaceAudit">使用照片审核</Button>
          <Button :disabled="!faceImg" @click="faceVerifyBtn">人工审核人脸识别</Button>
        </Row>
      </Card>
    </div>
    <Modal v-model="cardVerifyModel.display" :loading="true" ref="cardVerifyModel" title="人工审核身份证" ok-text="提交" @on-ok="subCard" @on-cancel="cancel">
      <Form ref="cardVerifyForm" :model="cardVerifyModel.data" :rules="cardVerRules">
        <FormItem label="姓名" :label-width="85" prop="name">
          <Input v-model="cardVerifyModel.data.name"></Input>
        </FormItem>
        <FormItem label="身份证号" :label-width="85" prop="cardId">
          <Input v-model="cardVerifyModel.data.cardId"></Input>
        </FormItem>
        <FormItem label="有效期" :label-width="85">
          <Row>
            <Col span="11">
              <FormItem prop="startDate">
                <DatePicker type="date" v-model="cardVerifyModel.data.startDate" format="yyyy.MM.dd" placeholder="生效日期" transfer></DatePicker>
              </FormItem>
            </Col>
            <Col span="2" style="text-align: center">至</Col>
            <Col span="11">
              <FormItem prop="endDate">
                <DatePicker type="date" v-model="cardVerifyModel.data.endDate" format="yyyy.MM.dd" placeholder="到期日期" transfer></DatePicker>
              </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="审核状态" :label-width="85" prop="status">
          <Select v-model="cardVerifyModel.data.status" transfer>
            <Option :value="2">已验证</Option>
            <Option :value="3">审核不通过</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="faceVerifyModel.display" :loading="true" title="人工审核人脸识别" ok-text="提交" @on-ok="subFace">
      <Form>
        <FormItem label="审核状态" :label-width="85">
          <Select v-model="faceVerifyModel.status" transfer>
            <Option :value="2">已验证</Option>
            <Option :value="3">审核不通过</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import {idNoRegular} from "../../../utils/regular";
import Moment from "moment";

export default {
  props: ['info','token','imgToken'],
  computed: {
    faceCanUpload() {
      return (this.faceInfo.status==0 || this.faceInfo.status==3)
    },
    cardCanUpload() {
      console.info(this.cardInfo.status==0);
      return (this.cardInfo.status==0 || this.cardInfo.status==3);
    },
  },
  watch: {
    info(val) {
      if(Object.keys(val).length !== 0) {
        this.btnLoading.omsCardBtn = false;
        this.btnLoading.omsFaceBtn = false;
        this.faceVerifyModel.display = false;
        this.cardInfo.name = val.name;
        this.cardInfo.phone = val.phone;
        this.cardInfo.userId = val.userId;
        this.cardInfo.cardId = val.idNo;
        this.cardInfo.startDate = val.idValidDate ? val.idValidDate.split('-')[0].replace(/\./g,'/') : '';
        this.cardInfo.endDate = val.idValidDate ? val.idValidDate.split('-')[1].replace(/\./g,'/') : '';
        this.cardInfo.idValidDate = val.idValidDate ? val.idValidDate: '';
        this.cardInfo.status = val.state;
        this.faceVerifyModel.status = val.faceState;
        this.faceImg = val.imageFace || "";
        this.cardImg.first = val.idImage?JSON.parse(val.idImage).frontImg:'';
        this.cardImg.second = val.idImage?JSON.parse(val.idImage).backImg:'';
        this.faceInfo = Object.assign({}, this.faceVerifyModel);
      }
    },
    token(val) {
      if(val) this.uploadData.token = val;
    },
    imgToken(val) {
      if(val && this.uploadRole) {
        this.uploadRole == 'uploadFirstCardImg' ? this.cardImg.first = val : this.uploadRole == 'uploadSecondCardImg' ? this.cardImg.second = val : this.faceImg = val;
        this.uploadRole = '';
      }
    }
  },
  data() {
    return {
      uploadRole: '',
      deadLine: parseInt(Date.now()/1000) + 7200,
      faceVerifyModel: {
        display: false,
        status: '',
      },
      cardImg: {
        first: '',
        second: ''
      },
      faceImg: '',
      cardInfo: {
        status: ''
      },
      faceInfo: {
        status: ''
      },
      cardVerifyModel: {
        display: false,
        data: {}
      },
      cardVerRules: {
        name:[
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        cardId:[
          { required: true, message: '请填写证件号码', trigger: 'blur' },
          { pattern: idNoRegular, message: '证件号码格式不正确', trigger: 'change' },
        ],
        startDate:[
          { required: true, type:'date', message: '请选择生效日期', trigger: 'change' }
        ],
        status:[
          { required: true, type:'number', message: '请选择审核状态', trigger: 'change' }
        ],
      },
      uploadData: {
        'token': '',
        'x:fileDirId:': -1,
        'x:isPrivate': 1,
        'x:remark': '' 
      },
      btnLoading: {
        omsCardBtn: false,
        omsFaceBtn: false
      }
    }
  },
  methods: {
    maxSizeErr(){
      this.$Notice.error({
        title: '图片上传失败',
        desc: '图片限制大小为：4Mb'
      })
    },
    cardVerifyBtn() {
      console.info(this.cardInfo);
      this.cardVerifyModel.data = Object.assign({},this.cardInfo);
      this.cardVerifyModel.display = true;
    },
    faceVerifyBtn() {
      if(this.cardInfo.status==2){
        this.faceVerifyModel.display = true;
      }else{
        this.$Notice.info({
          title: '请先验证身份证'
        })
      }
    },
    subFace() {
      let param = {
        auditStatus: this.faceVerifyModel.status,
        imageFace: this.faceImg,
        userId: this.cardInfo.userId
      }
      this.$emit('omsFaceAuditHandle', param);
    },
    subCard() {
      this.$refs.cardVerifyModel.buttonLoading = false;
      this.$refs.cardVerifyForm.validate((valid) => {
        if(valid) {
          this.cardVerifyModel.display = false;
          let endDate = Moment(this.cardVerifyModel.data.endDate).format('YYYY.MM.DD');
          endDate == 'Invalid date' && (endDate = '');
          let param = {
            backImg: this.cardImg.second.substring(0,this.cardImg.second.indexOf("?")),
            frontImg: this.cardImg.first.substring(0,this.cardImg.first.indexOf("?")),
            idNo: this.cardVerifyModel.data.cardId,
            idValidDate: `${Moment(this.cardVerifyModel.data.startDate).format('YYYY.MM.DD')}-${endDate}`,
            name: this.cardVerifyModel.data.name,
            phone: this.cardVerifyModel.data.phone,
            state: this.cardVerifyModel.data.status,
            userId: this.cardVerifyModel.data.userId
          }
          this.$emit('omsIdAudit',param);
          this.cardVerifyModel.data = {};
        }
      });
    },
    omsCardAudit() {
      this.btnLoading.omsCardBtn = true;
      let param = {
        backImg: this.cardImg.second.substring(0,this.cardImg.second.indexOf("?")),
        frontImg: this.cardImg.first.substring(0,this.cardImg.first.indexOf("?")),
        imgType: 2,
        phone: this.cardInfo.phone,
        userId: this.cardInfo.userId,
      }
      this.$emit('omsCardAudit', param);
    },
    omsFaceAudit() {
      this.btnLoading.omsFaceBtn = true;
      let param = {
        imageFace: this.faceImg.substring(0,this.faceImg.indexOf("?")),
        imgType: 2,
        phone: this.cardInfo.phone,
        userId: this.cardInfo.userId,
      }
      this.$emit('omsFaceAudit', param)
    },
    handleBeforeUpload(role) {
      this.uploadData["x:fileDirId"] = -1;
      this.uploadData["x:isPrivate"] = 1;
      this.uploadData["x:remark"] = "用户证件照";
      this.uploadRole = role;
    },
    handleSuccess(res) {
      let url = res.materialBase.url;
      this.$emit('getPrivateToken', url);
    },
    handleFormatError() {
      this.$Notice.warning({
        title: '文件类型不正确',
      });
    },
    cancel() {
      this.cardVerifyModel.data = {}
    }
  }
}
</script>

<style lang="scss" scoped>
  h5{
    text-align: center;
    margin-bottom: 5px;
  }
  .upload{
    text-align: center;
    cursor: pointer;
    .upload-box{
      padding-top: 60px;
    }
    .img-box{
      position: relative;
      width: 300px;
      height: 190px;
      padding-top: 0;
      background-color: #eee;
    }
  }
  .upload-bord{
    position: absolute;
    top: 0;
    padding-top: 60px;
    width: 300px;
    height: 190px;
    opacity: 0;
    background-color: #bcbcbc
  }
  .upload-bord:hover{
    opacity: 0.8;
  }
  .upload-box{
    display: inline-block;
    width: 300px;
    height: 190px;
    border: 1px solid #eee;
    background-color: #eee;
  }
  .cardImg{
    text-align: center;
  }
  .tableForm{
    margin-bottom:0 
  }
  img{
    width: 300px;
    height: 190px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/vip/vip-detail/authentication.vue